import './cases.css';

function ImageTrigger({index, selected, onSelect}) {

    return (

        <div className={selected ? "galery-main__imagetriggerselected" : "galery-main__imagetrigger"} onClick={() => onSelect(index)}></div>

    )


}

export default ImageTrigger;